
export const debounceFn = (fn, delay, immediate = true) => {
  let timer = null
  return function (...args) {
      /* eslint-disable */
      // @ts-ignore
      const context = this
      if (timer) clearTimeout(timer)
      immediate && !timer && fn.apply(context, args)
      timer = setTimeout(() => {
          timer = null
          !immediate && fn.apply(context, args)
      }, delay)
  }
}
// 处理全屏
export async function handleFullScreen(state, cb) {
    console.log(state, '处理全屏')
    const element = (document).documentElement

    if (state) {
        const requestFullFn = element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen
        try {
            await requestFullFn.call(element)
        } catch (error) {
            // eslint-disable-next-line no-unused-expressions
            cb && cb()
            // 尝试再开启全屏一次
            setTimeout(() => {
                requestFullFn.call(element)
            }, 2000)
        }
        // // 开启全屏状态
        // if (element.requestFullscreen) {
        //  res = await element.requestFullscreen()
        // } else if (element.webkitRequestFullScreen) {
        //   res = await element.webkitRequestFullScreen()
        // } else if (element.mozRequestFullScreen) {
        //   res = await element.mozRequestFullScreen()
        // } else if (element.msRequestFullscreen) {
        //   // IE11
        //   res = await element.msRequestFullscreen()
        // }

        // let rfs = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
        // if (typeof rfs != "undefined" && rfs) {
        //   rfs.call(element);
        // };
        // return;
    } else {
        // 退出全屏
        if ((document).exitFullscreen) {
            ;(document).exitFullscreen()
        } else if ((document).webkitCancelFullScreen) {
            ;(document).webkitCancelFullScreen()
        } else if ((document).mozCancelFullScreen) {
            ;(document).mozCancelFullScreen()
        } else if ((document).msExitFullscreen) {
            ;(document).msExitFullscreen()
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/index.js